import DriverRating from "components/driverRating";
import React from "react";

export default function AppDriverRating(){
  return (
    <DriverRating/>
  )
}